/** Trims a strength according to a max length, taking into account 3 characters for ..., meaning maxLength is actually 3 less than given. */
export function trimString(name: string, maxLength = 100) {
  if (name && name.length > maxLength) {
    return name.slice(0, maxLength - 3).trim() + "...";
  } else {
    return name;
  }
}
